/* eslint-disable */

// Import marker icons
import cavesIcon from "../../assets/markers/caves.svg";
import archaeologicalSitesIcon from "../../assets/markers/archaeological_sites.svg";
import substationPlannedIcon from "../../assets/markers/substation_planned.svg";
import substationOperationIcon from "../../assets/markers/substation_operation.svg";
import windPlannedIcon from "../../assets/markers/wind_planned.svg";
import windOperationIcon from "../../assets/markers/wind_operation.svg";
import hydroelectricOperationIcon from "../../assets/markers/hydroelectric_operation.svg";
import smallHydroelectricIcon from "../../assets/markers/small_hydroelectric.svg";
import cghBaseIcon from "../../assets/markers/CGH_Base.svg";
import biomassIcon from "../../assets/markers/biomass.svg";
import fossilFuelIcon from "../../assets/markers/fossil_fuel.svg";
import photovoltaicPlannedIcon from "../../assets/markers/photovoltaic_planned.svg";
import photovoltaicOperationIcon from "../../assets/markers/photovoltaic_operation.svg";
import portIcon from "../../assets/markers/port.svg";
import gnvStationIcon from "../../assets/markers/gnv_station.png";
import airportIcon from "../../assets/markers/airport.svg";
import businessHubIcon from "../../assets/markers/business_hub.svg";
import transformationNeoenergia from "../../assets/markers/station.svg";
import metroStationIcon from "../../assets/markers/metro_station.svg";
import telecomTowerIcon from "../../assets/markers/telecom_tower.svg";
import mineralOccurrenceIcon from "../../assets/markers/mineral_occurrence.svg";
import { VelocityLayerOptions } from "leaflet";

export type ServerType = "geoserver";
interface DisplayOptions {
  velocityType: string;
  position: "topleft" | "topright" | "bottomleft" | "bottomright" | undefined;
  speedUnit: "k/h" | "ms" | "mph" | "kt" | undefined;
  directionString: string;
  speedString: string;
}
export interface VelocityDisplayOptions {
  displayValues?: boolean;
  minVelocity?: number;
  maxVelocity?: number;
  velocityScale?: number;
  particleAge?: number;
  velocityType?: string; // Ex: "Vento"
  position?: "topleft" | "topright" | "bottomleft" | "bottomright";
  speedUnit?: string; // Ex: "k/h"
  directionString?: string; // Ex: "Direção"
  speedString?: string; // Ex: "Velocidade"
}

export interface VoltageOption {
  label: string;
  field: string; // GeoServer property field name (e.g., "vn" or "ten_kv")
  value: number | string;
  color?: string;
}

export interface SubLayerRef {
  displayTitle: string; // Label shown in the Camadas panel
  layerTitle: string; // Must match the `title` of the actual Layer entry
  color?: string;
}

export interface RasterRangeOverlay {
  layerName?: string;
  workspace?: string;
  styleName: string;
  contourLevels?: number[];
  opacity?: number;
  zIndexOffset?: number;
  detailedLayerName?: string;
  detailedLayerZoomThreshold?: number;
}

export interface Layer {
  title: string; // Display name
  cqlFilter?: string; // Static CQL filter always applied when this layer is rendered
  layerName: string; // Normalized identifier: lowercase_snake_case (e.g., "municipios_pe")
  wmsLayerName?: string; // Optional GeoServer layer/group name used for WMS rendering
  rasterRangeOverlay?: RasterRangeOverlay; // Optional WMS overlay shown above range-filtered rasters
  category: string; // Category that this layer belongs to (e.g., "Divisão política-administrativa")
  subcategory?: string; // Optional second level inside the category (e.g., "Solar" / "Eólico")
  /**
   * Lista a camada para todos os usuários, sem depender do `allowed_layers` do
   * Keycloak. Sem isso uma camada nova fica invisível até um admin concedê-la
   * usuário a usuário na tela de Administração de Camadas.
   */
  publicLayer?: boolean;
  type: string; // feature | wms | raster | particle
  // "wms": vetor cujo estilo vive num SLD do servidor (ver Serviços Geológicos do Brasil)
  id?: number;
  server?: ServerType;
  source?: String;
  endpoint?: string; // usado para hydro
  style?: LayerStyle;
  workspace?: string; // GeoServer workspace
  permanent?: boolean; // If true, layer is always visible and not user-selectable
  zIndex?: number; // Layer rendering priority (lower values render first/below)
  useWmsPreview?: boolean; // If true, use WMS GetMap image when zoomed out (for performance with large layers)
  minZoomForFeatures?: number; // Minimum zoom level to load actual features (default: load at all zooms)
  voltageOptions?: VoltageOption[]; // CQL filter options shown as Tensão submenu in Camadas panel
  voltageGroupLabel?: string; // Custom label for the voltageOptions section (default: "Tensão")
  voltageSubLayers?: SubLayerRef[]; // Independent sub-layers rendered inside the voltageOptions section
  subLayers?: SubLayerRef[]; // Independent layers rendered inline under this layer in the tree
  subLayerGroupLabel?: string; // Section title shown above subLayers checkboxes
  info?: string; // Tooltip de informação exibido ao lado do título na árvore de camadas
  chartButtonTooltip?: string; // Se definido, exibe um botão de gráfico ao lado do título na árvore; o texto é o tooltip do botão
  opacity?: number; // WMS layer opacity (0–1), defaults to 0.8
  temporal?: {
    enabled: boolean;
    dimension: string; // "time", "elevation" or a custom mosaic dimension ("direction", "year")
    format: string; // e.g., "YYYY-MM"
    range: { start: string; end: string };
    // Discrete values published by the ImageMosaic. When present the layer gets a
    // selector listing exactly these values instead of a free range. For custom
    // dimensions GeoServer expects them as DIM_<NAME> in the WMS request.
    values?: number[];
    label?: string; // Selector heading (defaults to the dimension name)
    unit?: string; // Suffix appended to each option (e.g., "m", "°")
  };
  velocityOptions?: VelocityLayerOptions | undefined; // Options for leaflet-velocity (particle layers)
  countGroupByField?: string; // quando definido, conta valores distintos desse campo em vez de features individuais
  detailedLayerName?: string; // For raster layers: alternate GeoServer layer name used when zoomed in past detailedLayerZoomThreshold
  detailedWmsLayerName?: string; // Optional detailed GeoServer layer/group name used when wmsLayerName is set
  detailedLayerZoomThreshold?: number; // Zoom level at which to switch to detailedLayerName (default: 12)
  manualLegend?: {
    label: string;
    countUnavailable?: boolean;
    legendItems?: Array<{
      label: string;
      color: string;
    }>;
  };
  // For "wms" layers: take the class legend from an ArcGIS MapServer
  // `/legend?f=json` endpoint instead of our GeoServer SLD. Entries are matched
  // to the layer's features by the leading "<sigla> - " of each label, so only
  // units present in the layer are listed.
  arcgisLegend?: {
    url: string;
    siglaField: string;
  };
}

export interface LayerStyle {
  hoverable?: boolean;
  customIcon?: string;
  customIconSize?: number;
}

/**
 * WMS parameter used to select a value of `dimension`. GeoServer exposes the
 * two standard dimensions under their own names and every custom ImageMosaic
 * dimension under `DIM_<NAME>` (e.g. "direction" → "DIM_DIRECTION").
 */
export function wmsDimensionParam(dimension: string): string {
  return dimension === "elevation" || dimension === "time"
    ? dimension
    : `DIM_${dimension.toUpperCase()}`;
}

/** First value the layer should show before the user picks one. */
export function defaultDimensionValue(layer: Layer): number {
  return layer.temporal?.values?.[0] ?? Number(layer.temporal?.range.start ?? 0);
}

/** Layers whose dimension is selectable through a numeric value list. */
export function hasSelectableDimension(layer: Layer): boolean {
  return (
    !!layer.temporal?.enabled &&
    layer.temporal.dimension !== "time" &&
    !!layer.temporal.values?.length
  );
}

/**
 * Camadas aeroespaciais específicas de Fernando de Noronha (todas nomeadas com
 * o sufixo/segmento `noronha`) ficam fora de `PE_MAINLAND_BOUNDS` — quem
 * enquadra o mapa para captura precisa saber disso para não deixá-las de fora.
 */
export function isFernandoNoronhaLayer(layer: Layer): boolean {
  return layer.layerName.toLowerCase().includes("noronha");
}

export const mockLayers: Layer[] = [
  // Divisão política-administrativa
  {
    title: "Municípios",
    layerName: "municipios_pe",
    category: "Divisão política-administrativa",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 402, // Above map tiles (400) but lowest priority among features
  },
  {
    title: "Regiões Imediatas",
    layerName: "regioes_imediatas_pe",
    category: "Divisão política-administrativa",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 401, // Above municipios but below other layers
  },
  {
    title: "Estado",
    layerName: "estado_pe",
    category: "Divisão política-administrativa",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    permanent: true,
    zIndex: 401, // Above municipios but below other layers
  },
  {
    title: "Estados da fronteira",
    layerName: "estados_bra",
    category: "Divisão política-administrativa",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 401,
  },

  // Infraestrutura de Energia - Planejado
  {
    title: "Linhas de Transmissão Planejadas",
    layerName: "linhas_de_transmissao_expansao_planejada",
    category: "Infraestrutura de Energia - Planejado",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
    voltageOptions: [
      { label: "230 kV", field: "vn", value: 230, color: "#54b04a" },
      { label: "500 kV", field: "vn", value: 500, color: "#db1e2a" },
      {
        label: "600 kV",
        field: "vn",
        value: 600,
        color: "rgba(255, 249, 1, 1)",
      },
    ],
    voltageGroupLabel: "Linha de transmissão (SIN - Rede Básica)",
  },
  {
    title: "Subestações Planejadas",
    layerName: "subestacoes_expansao_planejada",
    category: "Infraestrutura de Energia - Planejado",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: substationPlannedIcon,
    },
    zIndex: 403,
  },
  {
    title: "Parques Eólicos Planejados",
    layerName: "eol_expansao_planejada",
    category: "Infraestrutura de Energia - Planejado",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: windPlannedIcon,
    },
    zIndex: 403,
  },
  {
    title: "Usinas Fotovoltáicas Planejadas",
    layerName: "ufv_expansao_planejada",
    category: "Infraestrutura de Energia - Planejado",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: photovoltaicPlannedIcon,
    },
    zIndex: 403,
  },

  // Infraestrutura de Energia - Existente
  {
    title: "Linhas de Transmissão em Operação",
    layerName: "linhas_de_transmissao_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
    voltageOptions: [
      { label: "230 kV", field: "vn", value: 230, color: "#00ff00" },
      { label: "500 kV", field: "vn", value: 500, color: "#ff0000" },
    ],
    voltageGroupLabel: "Linha de transmissão (SIN - Rede Básica)",
    subLayers: [
      { displayTitle: "69 kV", layerTitle: "69 kV", color: "#d78cff" },
      {
        displayTitle: "138 kV",
        layerTitle: "138 kV",
        color: "rgba(249, 170, 40, 1)",
      },
    ],
    subLayerGroupLabel: "Linha de distribuição",
  },
  {
    title: "Subestações em Operação (SIN - Rede Básica)",
    layerName: "subestacoes_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: substationOperationIcon,
    },
    zIndex: 403,
  },
  // LTS Neoenergia - Rede de Distribuição AT (rendered as sub-layers of "Linhas de Transmissão em Operação")
  {
    title: "69 kV",
    layerName: "LTS-neoenergia",
    cqlFilter: "tensao_kv=69",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 499,
  },
  {
    title: "138 kV",
    layerName: "LTS-neoenergia",
    cqlFilter: "tensao_kv=138",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 498,
  },
  {
    title: "pepe-atlas:boundary_30km",
    layerName: "boundary_30km",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "pepe-atlas:boundary_100km",
    layerName: "boundary_100km",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "pepe-cog:potencial_teorico_solar",
    layerName: "potencial_teorico_solar",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_geografico_solar_PE",
    layerName: "potencial_geografico_solar_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_tecnico_solar_PE",
    layerName: "potencial_tecnico_solar_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_economico1_solar_PE",
    layerName: "potencial_economico1_solar_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_economico2_solar_PE",
    layerName: "potencial_economico2_solar_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_economico3_solar_PE",
    layerName: "potencial_economico3_solar_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_teorico_eolico",
    layerName: "potencial_teorico_eolico",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_geografico_eolico_PE",
    layerName: "potencial_geografico_eolico_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  {
    title: "pepe-cog:potencial_economico1_eolico_PE",
    layerName: "potencial_economico1_eolico_PE",
    category: "Projeções",
    server: "geoserver",
    workspace: "pepe-cog",
    type: "raster",
    zIndex: 489,
    opacity: 0.8,
  },
  /*{
    title: "Unidades Seccionadoras AT (Neoenergia)",
    layerName: "neoenergia_pe_unseat",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 405,
  },
  {
    title: "Unidades Consumidoras AT (Neoenergia)",
    layerName: "neoenergia_pe_uncrat",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 405,
  },
  {
    title: "Unidades de Rede AT (Neoenergia)",
    layerName: "neoenergia_pe_unreat",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 405,
  },
  */
  {
    title: "Subestações da rede de distribuição",
    layerName: "neoenergia_pe_untrat",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 405,
    style: {
      customIcon: transformationNeoenergia,
    },
    countGroupByField: "sub",
  },
  {
    title: "Conjuntos Elétricos - DGC (Neoenergia)",
    layerName: "neoenergia_pe_conj_dgc",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    // Abaixo dos pontos/linhas de infraestrutura: é um polígono de fundo.
    zIndex: 403,
    info: "Conjuntos elétricos coloridos pelo Desempenho Global de Continuidade (DGC) de 2025. Clique em um conjunto para ver a série anual de DEC e FEC apurados e seus limites regulatórios (ANEEL).",
    chartButtonTooltip: "Gerar gráfico para o estado inteiro",
  },
  /*{
    title: "Unidades Consumidoras MT (Neoenergia)",
    layerName: "neoenergia_pe_uncrmt",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 404,
  },
  {
    title: "Unidades de Rede MT (Neoenergia)",
    layerName: "neoenergia_pe_unremt",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 404,
  },
  {
    title: "Linhas de Distribuição MT (Neoenergia)",
    layerName: "neoenergia_pe_ssdmt",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 498,
    useWmsPreview: true, // Use WMS GetMap for preview when zoomed out
    minZoomForFeatures: 11, // Load features only at zoom 11+ (≈3km scale)
  },
  {
    title: "Unidades de Transformação MT (Neoenergia)",
    layerName: "neoenergia_pe_untrmt",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 404,
    useWmsPreview: true, // Use WMS GetMap for preview when zoomed out (120K+ features!)
    minZoomForFeatures: 11, // Load features only at zoom 11+ (≈3km scale)
  },*/
  {
    title: "Parques Eólicos em Operação",
    layerName: "eol_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: windOperationIcon,
    },
    zIndex: 403,
  },
  {
    title: "Usina Fotovoltáicas em Operação",
    layerName: "ufv_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: photovoltaicOperationIcon,
    },
    zIndex: 403,
  },
  {
    title: "Usinas Hidrelétricas em Operação",
    layerName: "uhe_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: hydroelectricOperationIcon,
    },
    zIndex: 403,
  },
  {
    title: "Pequenas Centrais Hidrelétricas",
    layerName: "pch_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: smallHydroelectricIcon,
    },
    zIndex: 403,
  },
  {
    title: "Centrais Geradoras Hidrelétricas",
    layerName: "cgh_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: cghBaseIcon,
    },
    zIndex: 403,
  },
  {
    title: "Usinas de Biomassa",
    layerName: "ute_biomassa_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: biomassIcon,
    },
    zIndex: 403,
  },
  {
    title: "Usina de Combustível Fóssil (Termelétricas)",
    layerName: "ute_fossil_base_existente",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: fossilFuelIcon,
    },
    zIndex: 403,
  },

  // Fatores Socioambientais
  {
    title: "Unidades de Conservação Ambiental",
    layerName: "unidades_conservacao_ambiental",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Territórios quilombolas",
    layerName: "area_quilombola",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Terras indígenas (Homologadas)",
    layerName: "terras_indigenas_homologadas",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Unidades Agrícolas Instaladas pelo INCRA",
    layerName: "assentamentos_publicos",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Sítios Arqueológicos",
    layerName: "sitios_arqueologicos",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: archaeologicalSitesIcon,
    },
    zIndex: 403,
  },
  {
    title: "Cavernas",
    layerName: "cavernas_pe",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: cavesIcon,
    },
    zIndex: 403,
  },
  {
    title: "Aves Migratórias (Áreas de concentração)",
    layerName: "aves_migratorias_areas_de_concentracao",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Áreas prioritárias para conservação da Caatinga (MMA)",
    layerName: "areas_prioritarias_conservacao_caatinga",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Áreas prioritárias para conservação da Mata Atlântica (MMA)",
    layerName: "areas_prioritarias_conservacao_mata_atlantica",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Áreas suscetíveis à desertificação",
    layerName: "areas_suscetiveis_desertificacao",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Zoneamento Agroecológico de Pernambuco",
    layerName: "zoneamento_agroecologico_pernambuco",
    category: "Fatores Socioambientais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },

  // Infraestrutura Logística
  {
    title: "Rodovias Federais",
    layerName: "rodovias_federais",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Rodovias Estaduais",
    layerName: "rodovias_estaduais",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 403,
  },
  {
    title: "Transnordestina - Trecho Ferroviário",
    layerName: "TRANSNORDESTINA-TRECHO-FERROVIÁRIO-VALEC-PE",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Portos",
    layerName: "portos",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: portIcon,
    },
    zIndex: 403,
  },
  {
    title: "Gasodutos de Transporte",
    layerName: "gasoduto_transporte_pe",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Gasodutos de Distribuição",
    layerName: "rede_copergas_geral",
    // A rede vem do WMS da Copergás como imagem, não como vetor, então cada
    // nível é um raster de resolução fixa. O geral (~11 m/px) tem traço cheio
    // de longe mas vira bloco no zoom de rua; o detalhe (~0,5 m/px) é nítido de
    // perto e some ao ser reduzido. z16 (~1:8.000) é onde um passa a ganhar do
    // outro — o mesmo corte usado pelo layer group proxy-copergas:rede_copergas,
    // que atende QGIS e demais clientes.
    detailedLayerName: "rede_copergas_detalhe",
    detailedLayerZoomThreshold: 16,
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "proxy-copergas",
    type: "wms",
    manualLegend: {
      label: "Gasodutos de Distribuição",
      countUnavailable: true,
      legendItems: [
        { label: "Rede em baixa pressão (≤ 7kgf/cm²)", color: "#ff0000" },
        { label: "Rede em alta pressão (> 7kgf/cm²)", color: "#4f86e8" },
      ],
    },
    opacity: 0.8,
    zIndex: 500,
  },
  {
    title: "Postos de GNV",
    layerName: "gnv_stations",
    category: "Infraestrutura de Energia - Em operação",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: gnvStationIcon,
    },
    zIndex: 403,
  },
  {
    title: "Hidrovias (Fluxo de Cabotagem)",
    layerName: "hidrovias_fluxo_de_cabotagem",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Aeroportos",
    layerName: "pe_aeroportos",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: airportIcon,
    },
    zIndex: 403,
  },
  {
    title: "Linhas de Metrô do Grande Recife",
    layerName: "linhas-de-trem-do-grande-recife",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Estações de Metrô do Grande Recife",
    layerName: "estacoes-de-trem-do-grande-recife",
    category: "Infraestrutura Logística",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: metroStationIcon,
    },
    zIndex: 403,
  },

  {
    title: "Fibra Óptica",
    layerName: "telecom-fibra-pe",
    category: "Telecomunicações",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Torres de Telecomunicação",
    layerName: "telecom-torres-pe",
    category: "Telecomunicações",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    style: {
      customIcon: telecomTowerIcon,
    },
    zIndex: 403,
  },

  // Infraestrutura Hídrica
  {
    title: "Canais",
    layerName: "canais",
    category: "Infraestrutura Hídrica",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Adutoras",
    layerName: "adutoras",
    category: "Infraestrutura Hídrica",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Rios",
    layerName: "rios",
    category: "Infraestrutura Hídrica",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 500,
  },
  {
    title: "Corpos d'água",
    layerName: "corpos_dagua",
    category: "Infraestrutura Hídrica",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    zIndex: 402,
  },

  {
    title: "Densidade de Potência Eólica (100m)",
    layerName: "DENSIDADE_POTENCIA_100m",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "pepe-raster",
    type: "raster",
    zIndex: 398,
    opacity: 0.6,
    info: "Densidade de Potência Eólica média anual a 100m de altura — recurso eólico disponível por unidade de área varrida pelo rotor.",
  },
  // A camada "Velocidade do Vento" (pepe-raster:windspeedtest) foi substituída
  // pelos mosaicos `mosaico_eolica_velocidade_pe` e `_noronha` do workspace
  // `aeroespacial`, que cobrem as mesmas alturas com um único store.
  // O nome `pepe-raster:windspeedtest` continua sendo usado fora da árvore de
  // camadas — distribuição de vento, estatísticas e o filtro de vento das
  // Projeções falam com o backend por esse identificador.
  {
    title: "Exemplo de circulação de alto nível",
    layerName: "wind_particles",
    category: "Climatologia",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "particle",
    zIndex: 450,
    temporal: {
      enabled: true,
      dimension: "time",
      format: "timestamp",
      range: { start: "1767366000000", end: "1767452400000" },
    },
    velocityOptions: {
      displayValues: true,
      minVelocity: 0,
      maxVelocity: 15,
      velocityScale: 0.005,
      particleAge: 64,
      lineWidth: 2,
      particleMultiplier: 1 / 300,
      displayOptions: {
        velocityType: "Vento",
        position: "bottomleft",
        speedUnit: "k/h" as const,
        directionString: "Direção",
        speedString: "Velocidade",
      },
    },
  },
  // ---------------------------------------------------------------------------
  // Dados aeroespaciais (workspace `aeroespacial`, COG servido do MinIO).
  // As camadas com `temporal.values` são ImageMosaics: um único store cobre
  // várias alturas/setores/anos e a dimensão é escolhida no seletor do mapa.
  // ---------------------------------------------------------------------------

  // --- Eólico ---
  {
    title: "Velocidade do Vento — Pernambuco",
    layerName: "mosaico_eolica_velocidade_pe",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Velocidade média anual do vento, selecionável por altura (10 a 200 m).",
    temporal: {
      enabled: true,
      dimension: "elevation",
      format: "number",
      range: { start: "10", end: "200" },
      values: [10, 50, 100, 140, 150, 200],
      label: "Altura",
      unit: "m",
    },
  },
  {
    title: "Velocidade do Vento — Fernando de Noronha",
    layerName: "mosaico_eolica_velocidade_noronha",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Velocidade média anual do vento em Fernando de Noronha, selecionável por altura (10 a 200 m).",
    temporal: {
      enabled: true,
      dimension: "elevation",
      format: "number",
      range: { start: "10", end: "200" },
      values: [10, 50, 100, 140, 150, 200],
      label: "Altura",
      unit: "m",
    },
  },
  {
    title: "Intensidade de Turbulência — Pernambuco",
    layerName: "mosaico_eolica_turbulencia_pe",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Intensidade de turbulência média (%), selecionável por altura (50 a 200 m). Diminui conforme a altura aumenta.",
    temporal: {
      enabled: true,
      dimension: "elevation",
      format: "number",
      range: { start: "50", end: "200" },
      values: [50, 100, 140, 150, 200],
      label: "Altura",
      unit: "m",
    },
  },
  {
    title: "Direção do Vento — Pernambuco",
    layerName: "mosaico_eolica_direcao_pe",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Frequência de ocorrência do vento (%) por setor de direção a 100 m. Os 12 setores somam 100% em cada ponto.",
    temporal: {
      enabled: true,
      dimension: "direction",
      format: "number",
      range: { start: "0", end: "330" },
      values: [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330],
      label: "Direção",
      unit: "°",
    },
  },
  {
    title: "Direção do Vento — Fernando de Noronha",
    layerName: "mosaico_eolica_direcao_noronha",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Frequência de ocorrência do vento (%) por setor de direção a 100 m em Fernando de Noronha.",
    temporal: {
      enabled: true,
      dimension: "direction",
      format: "number",
      range: { start: "0", end: "330" },
      values: [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330],
      label: "Direção",
      unit: "°",
    },
  },
  {
    title: "Variabilidade Interanual — Pernambuco",
    layerName: "mosaico_eolica_variabilidade_pe",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Índice de vento por ano (2016–2025) a 100 m. Valores próximos de 1 indicam ano na média histórica.",
    temporal: {
      enabled: true,
      dimension: "year",
      format: "number",
      range: { start: "2016", end: "2025" },
      values: [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
      label: "Ano",
    },
  },
  {
    title: "Variabilidade Interanual — Fernando de Noronha",
    layerName: "mosaico_eolica_variabilidade_noronha",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Índice de vento por ano (2016–2025) a 100 m em Fernando de Noronha.",
    temporal: {
      enabled: true,
      dimension: "year",
      format: "number",
      range: { start: "2016", end: "2025" },
      values: [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
      label: "Ano",
    },
  },
  {
    title: "Densidade de Potência Eólica (100m) — Fernando de Noronha",
    layerName: "eolica_fernando_de_noronha_100m_densidade_potencia",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Densidade de potência eólica média anual a 100 m em Fernando de Noronha.",
  },
  {
    title: "Weibull A (100m) — Pernambuco",
    layerName: "eolica_100m_weibull_a",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Parâmetro de escala A da distribuição de Weibull a 100 m, proporcional à velocidade média do vento.",
  },
  {
    title: "Weibull K (100m) — Pernambuco",
    layerName: "eolica_100m_weibull_k",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Parâmetro de forma k da distribuição de Weibull a 100 m. Valores maiores indicam vento mais constante.",
  },
  {
    title: "Weibull A (100m) — Fernando de Noronha",
    layerName: "eolica_fernando_de_noronha_100m_weibull_a",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Parâmetro de escala A da distribuição de Weibull a 100 m em Fernando de Noronha.",
  },
  {
    title: "Weibull K (100m) — Fernando de Noronha",
    layerName: "eolica_fernando_de_noronha_100m_weibull_k",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Parâmetro de forma k da distribuição de Weibull a 100 m em Fernando de Noronha.",
  },
  {
    title: "Velocidade de Referência VREF TR50 (100m) — Pernambuco",
    layerName: "eolica_100m_velocidade_referencia_vref_tr50",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Velocidade extrema de referência com período de retorno de 50 anos, a 100 m — usada na classificação IEC de turbinas.",
  },
  {
    title: "Velocidade de Referência VREF TR50 (100m) — Fernando de Noronha",
    layerName: "eolica_fernando_de_noronha_100m_velocidade_referencia_vref_tr50",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Velocidade extrema de referência com período de retorno de 50 anos, a 100 m, em Fernando de Noronha.",
  },
  {
    title: "Cisalhamento Médio do Vento",
    layerName: "eolica_shear_medio",
    category: "Mapa Solar e Eólico",
    subcategory: "Eólico",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Expoente médio de cisalhamento vertical do vento — indica quanto a velocidade cresce com a altura.",
  },

  // --- Solar ---
  {
    title: "Irradiação Direta Normal (DNI)",
    layerName: "solar_dni_200m_sirgas2000_anual",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Direct Normal Irradiation — média anual da irradiação solar direta em superfície perpendicular aos raios.",
  },
  {
    title: "Irradiação Difusa Horizontal (DHI)",
    layerName: "solar_dhi_200m_sirgas2000_anual",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Diffuse Horizontal Irradiation — média anual da parcela difusa da irradiação solar em superfície horizontal.",
  },
  {
    title: "Irradiação Global Horizontal (GHI)",
    layerName: "solar_ghi_200m_sirgas2000_anual",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Global Horizontal Irradiation — média anual da irradiação solar global em superfície horizontal, grade de 200 m em SIRGAS 2000.",
  },
  {
    title: "Insolação",
    layerName: "solar_insolacao_sirgas2000_200m_anual",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Número médio anual de horas de brilho solar.",
  },
  {
    title: "Albedo",
    layerName: "solar_albedo_sirgas2000_200m_anual",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    info: "Refletância média anual da superfície — influencia o ganho de módulos bifaciais.",
  },
  {
    title: "Albedo — Fernando de Noronha",
    layerName: "solar_albedo_noronha_sirgas2000_200m",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    detailedLayerName: "solar_albedo_noronha_sirgas2000_30m",
    info: "Refletância média anual da superfície em Fernando de Noronha. Ao aproximar o zoom, troca para a grade de 30 m.",
  },
  {
    title: "Altimetria",
    layerName: "solar_altimetria_sirgas2000_200m",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    detailedLayerName: "solar_altimetria_sirgas2000_30m",
    info: "Altitude do terreno. Ao aproximar o zoom, troca para a grade de 30 m.",
  },
  {
    title: "Declividade",
    layerName: "solar_declividade_sirgas2000_200m",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    detailedLayerName: "solar_declividade_sirgas2000_30m",
    info: "Inclinação do terreno em graus — restringe a área aproveitável para usinas. Ao aproximar o zoom, troca para a grade de 30 m.",
  },
  {
    title: "Rugosidade",
    layerName: "solar_rugosidade_sirgas2000_200m",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    detailedLayerName: "solar_rugosidade_sirgas2000_30m",
    info: "Rugosidade da superfície. Ao aproximar o zoom, troca para a grade de 30 m.",
  },
  {
    title: "Uso do Solo",
    layerName: "solar_uso_do_solo_sirgas2000_200m",
    category: "Mapa Solar e Eólico",
    subcategory: "Solar",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 397,
    opacity: 0.7,
    detailedLayerName: "solar_uso_do_solo_sirgas2000_30m",
    info: "Classes de cobertura e uso do solo. Ao aproximar o zoom, troca para a grade de 30 m.",
  },

  // Relevo (PE3D)
  {
    title: "Modelo digital de Terreno",
    layerName: "MOSAICO_100m_COG",
    wmsLayerName: "pe3d_with_contour",
    detailedWmsLayerName: "pe3d_with_contour_detailed",
    rasterRangeOverlay: {
      layerName: "MOSAICO_100m_COG",
      styleName: "contour-pe3d",
      contourLevels: [0, 200, 500, 800, 1200, 1800, 2500, 3200, 4000],
    },
    category: "Relevo (PE3D)",
    server: "geoserver",
    workspace: "pepe-raster",
    type: "raster",
    zIndex: 397,
    opacity: 0.8,
    detailedLayerName: "MOSAICO_otimizado",
    detailedLayerZoomThreshold: 12,
  },
  // Climatologia
  {
    title: "Temperatura Máxima",
    layerName: "solar_temperatura_tmax_200m_sirgas2000_anual",
    category: "Climatologia",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 396,
    opacity: 0.7,
    info: "Temperatura máxima média anual — relevante para a perda de eficiência de módulos fotovoltaicos.",
  },
  {
    title: "Precipitação Média Anual",
    layerName: "solar_precipitacao_media_anual_pe_200m_sirgas2000",
    category: "Climatologia",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 396,
    opacity: 0.7,
    info: "Precipitação acumulada média anual.",
  },
  {
    title: "Dias de Chuva",
    layerName: "solar_precipitacao_dias_chuva_medio_anual_pe_200m_sirgas2000",
    category: "Climatologia",
    server: "geoserver",
    workspace: "aeroespacial",
    publicLayer: true,
    type: "raster",
    zIndex: 396,
    opacity: 0.7,
    info: "Número médio de dias de chuva por ano — indicador de frequência de limpeza natural dos módulos.",
  },
  {
    title: "Umidade Relativa do Ar (Anual)",
    layerName: "UMIDADE_ANUAL",
    category: "Climatologia",
    server: "geoserver",
    workspace: "pepe-climatologia",
    type: "raster",
    zIndex: 395,
    opacity: 0.8,
  },
  // ---------------------------------------------------------------
  // Serviços Geológicos do Brasil (SGB/CPRM)
  // Subconjunto curado de 3 camadas (ATLAS-642) — o dataset completo do SGB
  // ingerido pelo Abraão tem ~30 camadas; só estas foram selecionadas para
  // exposição no Atlas. type "wms" = polígono temático com SLD oficial do
  // SGB no servidor.
  //
  // VISIBILIDADE: hoje só admin (e quem tem allowedLayers ["*"]) enxerga estas
  // camadas — useLayerPermissions exige o layerName na allowedLayers do usuário,
  // e nenhum perfil as tem. É intencional por ora, apesar de o dado ser aberto.
  // Para liberar a todos: incluir os layerNames nos perfis via AdminLayers, ou
  // introduzir um conceito de camada pública em canViewLayer.
  // ---------------------------------------------------------------
  {
    title: "Ocorrências de Recursos Minerais",
    layerName: "sgb_ocorrencias_recursos_minerais",
    category: "Serviços Geológicos do Brasil (SGB)",
    server: "geoserver",
    workspace: "sgb",
    type: "feature",
    zIndex: 405,
    useWmsPreview: true,
    minZoomForFeatures: 9,
    style: { customIcon: mineralOccurrenceIcon },
    info: "Fonte: Serviço Geológico do Brasil (SGB/CPRM) — geosgb:ocorrencias_recursos_minerais. Recorte: Pernambuco.",
  },
  {
    title: "Litoestratigrafia 1:1.000.000",
    layerName: "sgb_litoestratigrafia_1m",
    category: "Serviços Geológicos do Brasil (SGB)",
    server: "geoserver",
    workspace: "sgb",
    type: "wms",
    zIndex: 403,
    arcgisLegend: {
      url: "https://geoportal.sgb.gov.br/server/rest/services/geologia/litoestratigrafia_1000000/MapServer/legend?f=json",
      siglaField: "sigla",
    },
    info: "Fonte: Serviço Geológico do Brasil (SGB/CPRM) — geosgb:litoestratigrafia_1m. Recorte: Pernambuco.",
  },
  {
    title: "Suscetibilidade a Inundação",
    layerName: "sgb_suscet_inundacao",
    category: "Serviços Geológicos do Brasil (SGB)",
    server: "geoserver",
    workspace: "sgb",
    type: "wms",
    zIndex: 404,
    info: "Fonte: Serviço Geológico do Brasil (SGB/CPRM) — gestao-territorial:suscet_inundacao. Recorte: Pernambuco.",
  },
  {
    title: "Vocações Econômicas",
    layerName: "municipios_pe_adepe",
    category: "Arranjos Produtivos Locais",
    server: "geoserver",
    workspace: "pepe-atlas",
    type: "feature",
    publicLayer: true,
    zIndex: 401,
    info: "Cinco principais vocações econômicas de cada município, levantadas pela ADEPE. A cor do mapa segue a vocação principal.",
  },
];

/** Maps layerName → human-readable title for tooltip headers. */
export const layerTitleByName: Record<string, string> = Object.fromEntries(
  mockLayers.map((l) => [l.layerName, l.title])
);
